import { officeSeatFit, FIT_STYLE, FIT_LABEL, seatFitBands } from "./seatFit.js";
import { getAnalyticalSqft } from "../utils/locationSqftDerived.js";
import { T } from "../app/tokens.js";
export const SPACE_FIT_VERDICT_OVER = "Over-Cap";
export const SPACE_FIT_VERDICT_UNDER = "Under-Used";
export const SPACE_FIT_VERDICT_RIGHT = "Right-Sized";
export const SPACE_FIT_VERDICT_TIGHT = "Tight";
export const SPACE_FIT_VERDICT_DENSE = "Dense"; // independent density flag only
export const SPACE_FIT_COLOR = Object.fromEntries(seatFitBands().map(b => [b.label, b.style.ink]));
export const SPACE_FIT_BG = Object.fromEntries(seatFitBands().map(b => [b.label, b.style.bg]));
export const SPACE_FIT_BORDER = Object.fromEntries(seatFitBands().map(b => [b.label, b.style.border]));
export const SPACE_FIT_LABEL = Object.fromEntries(Object.values(FIT_LABEL).map(label => [label, { short: label, full: label }]));
export const SPACE_FIT_SEVERITY = { "Over-Cap": 0, Tight: 1, "Under-Used": 2, "Right-Sized": 3 };
export const SPACE_FIT_HEX = { "Over-Cap": T.ragRed, Tight: T.ragAmber, "Under-Used": T.ragAmber, "Right-Sized": T.greenDeep };
export const SPACE_FIT_MARKER_FALLBACK = T.mid;
export function computeOfficeSpaceFit(office) {
  return officeSeatFit({ ...office, analyticalSqft: getAnalyticalSqft(office) });
}
export { FIT_STYLE };
